import { Metamodel } from 'app/model/base/model';
import { RestServiceLinkedService } from 'app/model/linkedservice/rest-service.linkedservice';
import { SharePointOnlineListLinkedService } from 'app/model/linkedservice/sharepoint-online-list.linkedservice';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LinkedService, Pipeline, restAuthTypes, servicePrincipalCredentialTypes } from 'shell-models-lib';

function usesRetiredSharePointSpnKey(linkedService: LinkedService): boolean {
    const linkedServiceType = Metamodel.modelOf(linkedService).name;
    if (linkedServiceType === adfModelTypeMap.sharePointOnlineList.linkedServiceType) {
        const sharePointLinkedService = linkedService as SharePointOnlineListLinkedService;
        return sharePointLinkedService.isOldServicePrincipalResource
            || sharePointLinkedService.servicePrincipalCredentialType === servicePrincipalCredentialTypes.ServicePrincipalKey;
    }
    if (linkedServiceType === adfModelTypeMap.rest.linkedServiceType) {
        const restLinkedService = linkedService as RestServiceLinkedService;
        return restLinkedService.isSharePointUrl
            && restLinkedService.authenticationType === restAuthTypes.AadServicePrincipal
            && (
                restLinkedService.isOldServicePrincipalResource
                || restLinkedService.servicePrincipalCredentialType === servicePrincipalCredentialTypes.ServicePrincipalKey
            );
    }
    return false;
}

export function calcSharePointSpnWarning(pipeline: Pipeline, visited: Set<Pipeline> = new Set()): void {
    if (!pipeline || visited.has(pipeline)) {
        return;
    }
    visited.add(pipeline);
    pipeline.showSharePointSpnWarning = false;
    pipeline.sharePointSpnLinkedService = undefined;
    for (const activity of pipeline.activities) {
        const act = activity as {
            sourceDataset?: { linkedService?: LinkedService };
            sinkDataset?: { linkedService?: LinkedService };
            linkedService?: LinkedService;
            dataset?: { linkedService?: LinkedService };
            pipeline?: Pipeline;
            defaultPipeline?: Pipeline;
            cases?: Array<{ casePipeline?: Pipeline }>;
            ifFalseActivityPipeline?: Pipeline;
            ifTrueActivityPipeline?: Pipeline;
        };
        const linkedServices = [
            act.sourceDataset?.linkedService,
            act.sinkDataset?.linkedService,
            act.linkedService,
            act.dataset?.linkedService
        ];
        const sharePointSpnLinkedService = linkedServices.find(
            (linkedService) => linkedService && usesRetiredSharePointSpnKey(linkedService)
        );
        if (sharePointSpnLinkedService) {
            pipeline.showSharePointSpnWarning = true;
            pipeline.sharePointSpnLinkedService = sharePointSpnLinkedService;
            return;
        }
        if (act.pipeline) {
            calcSharePointSpnWarning(act.pipeline, visited);
            pipeline.showSharePointSpnWarning = act.pipeline.showSharePointSpnWarning;
            pipeline.sharePointSpnLinkedService = act.pipeline.sharePointSpnLinkedService;
        } else if (act.defaultPipeline) {
            calcSharePointSpnWarning(act.defaultPipeline, visited);
            pipeline.showSharePointSpnWarning = act.defaultPipeline.showSharePointSpnWarning;
            pipeline.sharePointSpnLinkedService = act.defaultPipeline.sharePointSpnLinkedService;
            if (!pipeline.showSharePointSpnWarning && act.cases) {
                for (const caseItem of act.cases) {
                    calcSharePointSpnWarning(caseItem.casePipeline, visited);
                    if (caseItem.casePipeline?.showSharePointSpnWarning) {
                        pipeline.showSharePointSpnWarning = true;
                        pipeline.sharePointSpnLinkedService = caseItem.casePipeline.sharePointSpnLinkedService;
                        break;
                    }
                }
            }
        } else if (act.ifFalseActivityPipeline || act.ifTrueActivityPipeline) {
            if (act.ifFalseActivityPipeline) {
                calcSharePointSpnWarning(act.ifFalseActivityPipeline, visited);
                pipeline.showSharePointSpnWarning = act.ifFalseActivityPipeline.showSharePointSpnWarning;
                pipeline.sharePointSpnLinkedService = act.ifFalseActivityPipeline.sharePointSpnLinkedService;
            }
            if (!pipeline.showSharePointSpnWarning && act.ifTrueActivityPipeline) {
                calcSharePointSpnWarning(act.ifTrueActivityPipeline, visited);
                pipeline.showSharePointSpnWarning = act.ifTrueActivityPipeline.showSharePointSpnWarning;
                pipeline.sharePointSpnLinkedService = act.ifTrueActivityPipeline.sharePointSpnLinkedService;
            }
        }
        if (pipeline.showSharePointSpnWarning) {
            return;
        }
    }
}